var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"--large",class:{ '--dark': _vm.color === 'dark', '--white': _vm.color === 'white' },attrs:{"type":"submit"}},[_c('span',{staticClass:"btn__stroke"}),_c('span',{staticClass:"btn__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }